/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { EdiOutboundInvoiceResponse } from "./EdiOutboundInvoiceResponse";
import {
  EdiOutboundInvoiceResponseFromJSON,
  EdiOutboundInvoiceResponseFromJSONTyped,
  EdiOutboundInvoiceResponseToJSON,
  EdiOutboundInvoiceResponseToJSONTyped,
} from "./EdiOutboundInvoiceResponse";

/**
 *
 * @export
 * @interface EdiOutboundInvoicesPage
 */
export interface EdiOutboundInvoicesPage {
  /**
   *
   * @type {Array<EdiOutboundInvoiceResponse>}
   * @memberof EdiOutboundInvoicesPage
   */
  rows: Array<EdiOutboundInvoiceResponse>;
  /**
   *
   * @type {number}
   * @memberof EdiOutboundInvoicesPage
   */
  totalCount: number;
}

/**
 * Check if a given object implements the EdiOutboundInvoicesPage interface.
 */
export function instanceOfEdiOutboundInvoicesPage(
  value: object,
): value is EdiOutboundInvoicesPage {
  if (!("rows" in value) || value["rows"] === undefined) return false;
  if (!("totalCount" in value) || value["totalCount"] === undefined)
    return false;
  return true;
}

export function EdiOutboundInvoicesPageFromJSON(
  json: any,
): EdiOutboundInvoicesPage {
  return EdiOutboundInvoicesPageFromJSONTyped(json, false);
}

export function EdiOutboundInvoicesPageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EdiOutboundInvoicesPage {
  if (json == null) {
    return json;
  }
  return {
    rows: (json["rows"] as Array<any>).map(EdiOutboundInvoiceResponseFromJSON),
    totalCount: json["totalCount"],
  };
}

export function EdiOutboundInvoicesPageToJSON(
  json: any,
): EdiOutboundInvoicesPage {
  return EdiOutboundInvoicesPageToJSONTyped(json, false);
}

export function EdiOutboundInvoicesPageToJSONTyped(
  value?: EdiOutboundInvoicesPage | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    rows: (value["rows"] as Array<any>).map(EdiOutboundInvoiceResponseToJSON),
    totalCount: value["totalCount"],
  };
}
